import { SVGProps, Ref, forwardRef } from 'react';

export const WalletOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.996 7.332c0-4.666-.667-5.332-5.332-5.332H5.332C.667 2 0 2.666 0 7.332v1.333c0 4.665.667 5.332 5.332 5.332h5.332c4.666 0 5.332-.667 5.332-5.332zm-1.406-.7q.006.326.006.7v1.333c0 1.155-.043 1.96-.153 2.542-.107.568-.252.782-.353.883s-.316.247-.884.354c-.581.11-1.386.153-2.542.153H5.332c-1.156 0-1.96-.044-2.542-.153-.568-.107-.783-.253-.884-.354s-.246-.315-.353-.883c-.11-.582-.153-1.387-.153-2.542V7.332q0-.374.006-.7h4.102c.452 1.004 1.24 1.7 2.49 1.7s2.038-.696 2.49-1.7zm-.081-1.4a6 6 0 0 0-.066-.443c-.107-.567-.252-.782-.353-.883s-.316-.247-.884-.354c-.581-.11-1.386-.152-2.542-.152H5.332c-1.156 0-1.96.043-2.542.152-.568.107-.783.253-.884.354s-.246.316-.353.883a6 6 0 0 0-.066.443l5.041-.002c.082.4.2.745.35 1.016.26.467.577.685 1.12.685s.86-.218 1.12-.685c.15-.271.268-.616.35-1.016z"
                fill="currentColor"
            />
        </g>
    </svg>
));
WalletOutlinedSize16Glyph.displayName = 'WalletOutlinedSize16Glyph';
